import { useLanguage } from "contexts/LocalizationContext";
import { useDeviceSize } from "hooks";
import { TopBanner } from "modules/common/components";
import ReturningUsersNotification from "modules/common/components/ReturningUsersNotification";
import { HeaderDesktop } from "./HeaderDesktop/HeaderDesktop";
import { HeaderMobile } from "./HeaderMobile";
import { HeaderWrapper } from "./HeaderWrapper";
import type { HeaderProps } from "./types";

export const Header = ({
  headerLogo,
  headerLinks,
  headerActionButton,
  sideMenuContent,
  topBannerText,
  topBannerButtonText,
  hideFlagBox,
}: HeaderProps) => {
  const pageLanguage = useLanguage();
  const { isDesktop } = useDeviceSize();

  return (
    <HeaderWrapper
      topBannerComponent={<TopBanner bannerText={topBannerText} buttonText={topBannerButtonText} />}
      returningUsersNotification={<ReturningUsersNotification />}
    >
      {isDesktop ? (
        <HeaderDesktop
          headerLinks={headerLinks}
          pageLanguage={pageLanguage}
          headerLogo={headerLogo}
          headerActionButton={headerActionButton}
          hideFlagBox={hideFlagBox}
        />
      ) : (
        <HeaderMobile
          headerLinks={headerLinks}
          pageLanguage={pageLanguage}
          headerLogo={headerLogo}
          headerActionButton={headerActionButton}
          sideMenuContent={sideMenuContent}
          hideFlagBox={hideFlagBox}
        />
      )}
    </HeaderWrapper>
  );
};
